import React from "react";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

const RowLink = ({ link, title, classes, view }) => {
  if (view) {
    return (
      <Button
        component={Link}
        to={link}
        mini
        raised={link.includes("subtest") ? false : true}
        className={classes.wow}
      >
        {link.includes("subtest") ? <Icon>edit</Icon> : null}
        {title}
      </Button>
    );
  } else {
    return (
      <Button component={Link} to={link} mini dense raised>
        {title}
      </Button>
    );
  }
};

export default withStyles(styles)(RowLink);



// WEBPACK FOOTER //
// ./src/components/table/cells/rowlink/index.js